module.exports = __webpack_public_path__ + "img/ucentric.32f671da.png";